import { useMemo } from "react";
import { useTheme } from "styled-components";
import { systemColors } from "../../../theme/styled-theme";
const ARROW_HEIGHT = 5;
const ARROW_WIDTH = 10;
export const useArrow = (colorType = "dark") => {
    const theme = useTheme();
    return useMemo(() => {
        const base = {
            height: ARROW_HEIGHT,
            width: ARROW_WIDTH,
        };
        if (colorType === "dark") {
            return { ...base, fill: theme.systemColors.grey800 };
        }
        if (colorType === "light") {
            return {
                ...base,
                fill: theme.systemColors.white,
                stroke: theme.systemColors.grey300,
                strokeWidth: 1,
                style: {
                    transform: "translateY(-1px)",
                },
            };
        }
        if (colorType === "grey") {
            return { ...base, fill: systemColors.grey100 };
        }
        return base;
    }, [colorType, theme.systemColors]);
};
